<div class="container-fluid my-5">
    <div class="card shadow">
        <div class="card-header border-0">

            <h3 class="mb-0">Mes factures</h3>
        </div>
        <!-- liste des moyens de paiement -->
        <div class="card-body border-0 p-0">
            <div class="table-responsive">
                <table class="table align-items-center table-flush">
                    <thead class="thead-light">
                        <tr>
                            <th scope="col">Description</th>
                            <th scope="col">Total à payer</th>
                            <th scope="col">Status</th>
                            <th scope="col">Date de création</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let invoice of invoices">
                            <td>
                                <div [innerHTML]="invoice.description"></div>
                            </td>
                            <td>{{invoice.amount_due.toFixed(2)}} €</td>
                            <td>
                                <span class="badge badge-success"
                                    *ngIf="invoice.status == 'paid'">{{invoice.status_value() }}</span>
                                <span class="badge badge-secondary"
                                    *ngIf="invoice.status == 'draft'">{{invoice.status_value() }}</span>
                                <span class="badge badge-danger"
                                    *ngIf="invoice.status != 'paid' && invoice.status != 'draft'">{{invoice.status_value()
                                    }}</span>
                            </td>
                            <td>{{ timestamp_to_date_format(invoice.created) }}</td>
                            <td>
                                <a class="text-black-50"
                                    [href]="(invoice.status == 'paid') ? invoice.invoice_pdf : invoice.hosted_invoice_url"
                                    target="_blank" *ngIf="invoice.status != 'draft'">
                                    <i class="fa fa-download pe-2 text-info"></i>
                                </a>
                                <span *ngIf="invoice.status == 'draft'">En cours de traitement...</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="text-center font-weight-bold mt-3" *ngIf="loading">
                Chargement...</p>
            <p class="text-center font-weight-bold mt-3" *ngIf="invoices.length == 0 && !loading">
                Aucun élément trouvé</p>
            <div class="w-100 text-center my-3">
                <button class="btn btn-outline-dark" (click)="get_more()" *ngIf="has_more && !loading">Voir
                    plus</button>
            </div>
        </div>
    </div>
</div>